import { showToast } from "vant";
export default {
  name: "TipForm",
  props: {
    amount: {
      type: String,
      require: false,
      default: ""
    },
    cancelClick: {
      type: Function,
      require: false,
      default: null
    },
    enterClick: {
      type: Function,
      require: false,
      default: null
    }
  },
  watch: {
    amount() {
      this.inputAmount = this.amount;
    }
  },
  data() {
    return {
      inputAmount: this.amount
    };
  },
  methods: {
    amountInput() {
      if (this.inputAmount && parseInt(this.inputAmount) < 1) {
        this.inputAmount = null;
      }
      if (this.inputAmount && parseInt(this.inputAmount) > 100) {
        showToast("调度费金额超过限制");
        this.inputAmount = null;
      }
    },
    cancelButtonClick() {
      if (this.cancelClick) {
        this.cancelClick();
      }
    },
    enterButtonClick() {
      if (this.inputAmount && this.inputAmount.trim().length > 0) {
        if (parseInt(this.inputAmount) < 1 || parseInt(this.inputAmount) > 100) {
          showToast("调度费金额输入不正确");
          return;
        }
      } else {
        this.cancelButtonClick();
        return;
      }
      if (this.enterClick) {
        this.enterClick(this.inputAmount);
      }
    }
  }
};